import React from 'react';
import {Link} from 'react-router-dom';
// import NewActiveUsers from '../Widgets/NewActiveUsers';
import ActiveUsers from '../Widgets/ActiveUsers';
import NewUsersFunnel from '../Widgets/NewUsersFunnel';
import Platforms from '../Widgets/Platforms';
import Registrations from '../Widgets/Registrations';
import SeasonActiveUsersWidget from '../Widgets/SeasonActiveUsers';
import UserConnections from '../Widgets/UserConnections';
import UsersByChampionshipWidget from '../Widgets/UsersByChampionship';
import UsersRetentionWidget from '../Widgets/UsersRetention';

export default () => (
  <div id="statistics-users">
    <header className="content-header">
      <h1>
        Statistics
        <small>Users</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-bar-chart" /> Statistics
        </li>
        <li className="text-bold">
          <Link to="/statistics/users">Users</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <Registrations />
      <div className="row">
        <div className="col-md-6">
          <UserConnections />
        </div>
        <div className="col-md-6">
          <Platforms />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <SeasonActiveUsersWidget />
        </div>
        <div className="col-md-6">
          <UsersByChampionshipWidget />
        </div>
        <div className="col-md-6">
          <ActiveUsers />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <UsersRetentionWidget />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <NewUsersFunnel />
        </div>
      </div>
    </section>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Users/index.js